export default function isBoolean(x: any): boolean {
  return typeof x === 'boolean'
}
